const querystring = require('querystring')
const Emitter = require('tiny-emitter')

const endpoints = require('./endpoints.json')
const bodyMethods = ['post', 'delete', 'patch', 'put']

const createFetcher = () => {
  const apiUrl = process.env.API_URL.substr(-1) === '/' ?
    process.env.API_URL.substr(0, process.env.API_URL.length-1) : process.env.API_URL

  return async function (path, endpointConf, fetchConf) {
    const headers = new Headers({accept: 'application/json'})

    if (endpointConf.contentType === 'json') {
      headers.set('content-type', 'application/json')
      if (fetchConf.body) {
        fetchConf.body = JSON.stringify(fetchConf.body)
      }
    }

    const result = await fetch(apiUrl + path, Object.assign({
      headers,
      method: endpointConf.method,
      credentials: 'include'
    }, fetchConf))

    if (result.headers.has('content-type')) {
      if(result.headers.get('content-type').match(/^application\/json/i)) {
        result.data = await result.json()
      } else if(result.headers.get('content-type').match(/^application\/pdf/i)) {
        result.data = await result.blob()
      } else {
        result.data = await result.text()
      }
    } else {
      result.data = await result.text()
    }

    if (result.status.toString().substr(0,1) !== '2') {
      throw result
    }

    return result
  }
}

function extractParameters(endpoint) {
  const regex = /\{([a-z]+)\}/ig
  const parameters = []
  let matches = null
  while ((matches = regex.exec(endpoint)) !== null) {
    parameters.push(matches[1])
  }
  return parameters
}

function createCaller(fetcher, endpointConf) {
  const parameters = extractParameters(endpointConf.endpoint)
  const emitter = new Emitter()

  const caller = function(body = null, userConf = {}) {
    let path = endpointConf.endpoint
    for (let i = 0; i < parameters.length; i++) {
      const parameter = userConf[parameters[i]] || body[parameters[i]]
      if (parameter === undefined || parameter === null) {
        throw new Error(`Parameter "${parameters[i]}" must be defined`)
      }
      path = path.replace(`{${parameters[i]}}`, parameter)
    }

    if (bodyMethods.includes(endpointConf.method.toLowerCase()) && body && !endpointConf.upload) {
      userConf.body = body
    }

    if ((userConf.qs) || (body && endpointConf.method.toLowerCase() === 'get')) {
      const qs = Object.assign({}, userConf.qs || {}, body || {})
      path += '?' + querystring.stringify(qs)
      delete userConf.qs
    }

    return fetcher(path, endpointConf, userConf)
      .then((r) => {
        emitter.emit('success', r)
        return r
      })
      .catch((r) => {
        emitter.emit('error', r)
        throw r
      })
  }

  for (let key in emitter) {
    caller[key] = emitter[key].bind(emitter)
  }

  return caller
}

function createTree(fetcher, endpoints) {
  const object = {}

  for (let name in endpoints) {
    const conf = endpoints[name]
    if (conf.method) {
      object[name] = createCaller(fetcher, conf)
    } else {
      object[name] = createTree(fetcher, conf)
    }
  }

  return object
}

export default createTree(createFetcher(), endpoints)
